import PropTypes from 'prop-types';

export default function MediaItemPlaceholder({item}) {
    return (
        <div className="w-full flex-shrink-0 px-2">
            <div
                className="aspect-video bg-zinc-800 rounded-xl border border-zinc-700/50 flex items-center justify-center hover:border-amber-500/30 transition-colors">
                <div className="text-center">
                    {item.type === 'video' ? (
                        <svg
                            className="w-12 h-12 text-zinc-600 mx-auto mb-2"
                            fill="currentColor"
                            viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z"/>
                        </svg>
                    ) : (
                        <svg
                            className="w-12 h-12 text-zinc-600 mx-auto mb-2"
                            fill="currentColor"
                            viewBox="0 0 24 24">
                            <path
                                d="M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"/>
                        </svg>
                    )}
                    <p className="text-zinc-500 text-sm">{item.placeholder}</p>
                </div>
            </div>
        </div>
    );
}

MediaItemPlaceholder.propTypes = {
    item: PropTypes.shape({
        type: PropTypes.string.isRequired,
        placeholder: PropTypes.string.isRequired,
    }).isRequired,
};
